export interface HourOption {
    value: string;
    label: string;
}

let allDayLabel = 'ALL DAY'
let openEndLabel = 'OPEN END'

export function setAllDayLabel(label: string): void {
    allDayLabel = label
}

export function getAllDayLabel(): string {
    return allDayLabel;
}

export function setOpenEndLabel(label: string): void {
    openEndLabel = label
}

export function getOpenEndLabel(): string {
    return openEndLabel;
}

/**
 * Generates hour options for start and end time dropdowns.
 *
 * - startHourOptions: 00:00 to 23:45 in 15-min steps, plus "ALL DAY" entries (before 12:00 and at end)
 * - endHourOptions: 00:00 to 23:45 in 15-min steps, plus "OPEN END" entries (at start and end)
 */
export function getHourOptions(): { startHourOptions: HourOption[], endHourOptions: HourOption[] } {
    const hourOptions: HourOption[] = [];
    let startHourOptions: HourOption[]
    let endHourOptions: HourOption[]

    // loop from 0 to 24
    for (let index = 0; index < 24; index++) {
        let hour: string;
        if (index < 10) {
            hour = '0' + index.toString();
        } else {
            hour = index.toString();
        }
        const zero = hour + ':00';
        const fifteen = hour + ':15';
        const thirty = hour + ':30';
        const fourtyFive = hour + ':45';
        hourOptions.push({ value: zero, label: zero });
        hourOptions.push({ value: fifteen, label: fifteen });
        hourOptions.push({ value: thirty, label: thirty });
        hourOptions.push({ value: fourtyFive, label: fourtyFive });
    }
    startHourOptions = [
        ...hourOptions,
        { value: '', label: allDayLabel },
    ];
    // add the all day just before 12:00
    startHourOptions.splice(48, 0, {
        value: '',
        label: allDayLabel,
    });
    endHourOptions = [
        { value: '', label: openEndLabel },
        ...hourOptions,
        { value: '', label: openEndLabel },
    ];
    return { startHourOptions: startHourOptions, endHourOptions: endHourOptions }
}
